import { userStore } from "@/stores/modules/user";
import { ElUpload as eleUpload } from "element-plus";
export default defineComponent({
  name: "ElUpload",
  extends: eleUpload,
  props: {
    action: {
      type: String,
      default: process.env.VUE_APP_UPLOAD
    },
    headers: {
      default: () => {
        return {
          token: userStore().userInfo.token
        };
      }
    }
  },
  setup(props, ctx) {
    return eleUpload.setup?.(props, ctx);
  }
});